<template>
  <div>
    <div>
      <div style="width:425px">        
      <BasicTableComponent :list="store.data" :formatters="formatters" :titles="titles" :isUpdating="store.dataIsUpdating">
        <div slot="header">{{store.location}}
          <span v-if="store.isPayAtPump"> - Pay At Pump</span>
        </div>
      </BasicTableComponent>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PumpStatus',
  inject:['pumpStatusPage'],
  props:['storeName'],
  data(){return {
    //Shift into props with defaults?
    formatters: {
      'pump_number': ['n', '0'],
      'ppu': ['n', '0.000'],
      'date' : ['d', 'ddd h:mm a'],
      'ts' : ['humanize']
    },
    //Shift into props with defaults?
    titles: {
      'ts': 'Last Used',
      'ppu': 'PPU'
    },
  }},
  computed:{
    pumpStatusStore(){
      return this.pumpStatusPage.$refs[this.storeName]
    },
    store(){
      return this.pumpStatusStore
    }
  },
}
</script>

<style>
</style>
